/* ============================================================
   ABANA HOMES — Dawn Revamp custom JS
   Loaded deferred, after global.js / pubsub.js / constants.js.
   ============================================================ */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     PHASE 3a — Desktop hover-to-open header dropdowns
     Only on pointer devices >= 990px. Mobile keeps native tap.
     --------------------------------------------------------- */
  var hoverMQ = window.matchMedia('(hover: hover) and (min-width: 990px)');

  function bindHover() {
    var menus = document.querySelectorAll('.header__inline-menu header-menu');
    menus.forEach(function (hm) {
      if (hm.dataset.ahHover) return;
      var details = hm.querySelector('details');
      if (!details) return;
      hm.dataset.ahHover = '1';
      var summary = details.querySelector('summary');
      var closeTimer;

      hm.addEventListener('mouseenter', function () {
        if (!hoverMQ.matches) return;
        clearTimeout(closeTimer);
        if (!details.open) {
          details.setAttribute('open', '');
          if (summary) summary.setAttribute('aria-expanded', 'true');
        }
      });
      hm.addEventListener('mouseleave', function () {
        if (!hoverMQ.matches) return;
        // delay so moving from summary into the submenu doesn't snap it shut
        closeTimer = setTimeout(function () {
          if (typeof hm.close === 'function') {
            hm.close(); // Dawn's own close(): clears open + aria, keeps state in sync
          } else {
            details.removeAttribute('open');
            if (summary) summary.setAttribute('aria-expanded', 'false');
          }
        }, 220);
      });
    });
  }

  /* ---------------------------------------------------------
     PHASE 3b — Keep mobile bottom-nav cart count in sync
     --------------------------------------------------------- */
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
  }

  function setCartCount(n) {
    document.querySelectorAll('[data-ah-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', Number(n) === 0);
    });
    // Keep Dawn's header bubble in sync too
    document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(function (el) {
      el.textContent = n;
    });
  }

  function refreshCartCount() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) setCartCount(c.item_count); return c; })
      .catch(function () { return null; });
  }

  // Swap the freshly-rendered cart-drawer + icon-bubble HTML into the page.
  // `sections` is a { '<section-id>': '<html>' } map as returned by either the
  // Section Rendering API (/cart?sections=...) or — preferred for mutations —
  // the `sections` key on a cart AJAX response (/cart/add|update|change.js).
  function swapDrawerSections(sections) {
    if (!sections) return;
    function swap(html, selector) {
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector(selector);
      var live = document.querySelector(selector);
      if (fresh && live) live.innerHTML = fresh.innerHTML;
    }
    swap(sections['cart-icon-bubble'], '#cart-icon-bubble');
    swap(sections['cart-drawer'], 'cart-drawer');
    // Re-bind per-element controls in the fresh drawer. Promo is delegated
    // (bound once on document) so it needs no re-bind here.
    var drawer = document.querySelector('cart-drawer');
    if (drawer) { bindCartAdd(drawer); }
  }

  // Re-render the cart drawer + icon bubble from the server so AJAX changes
  // (e.g. the shears add-on) show up without a page reload. Fetches via /cart,
  // NOT '/' — Shopify serves '/?sections=...' through the homepage's full-page
  // cache (IndexController), which can return a stale snapshot of the
  // cart-drawer section (wrong totals/promo state right after an AJAX change).
  // /cart is never full-page-cached. NOTE: this is a SEPARATE read after the
  // write, so it can still race a just-committed mutation — for discount
  // apply we render from the mutation's own `sections` payload instead (atomic,
  // no read-after-write lag; see apply()).
  function updateCartUI() {
    return fetch(root() + 'cart?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) { swapDrawerSections(s); })
      .catch(function () {});
  }

  function bindCartSync() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      if (window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (e) {
          refreshCartCount();
          // Dawn re-renders the drawer on qty/remove/add → re-bind per-element
          // controls. Promo is delegated (document-level) so it isn't re-bound.
          var drawer = document.querySelector('cart-drawer');
          if (drawer) { bindCartAdd(drawer); }
        });
      }
      if (window.PUB_SUB_EVENTS.cartError) window.subscribe(window.PUB_SUB_EVENTS.cartError, refreshCartCount);
    }
  }

  /* ---------------------------------------------------------
     PHASE 5a — Gift message reveal (keeps empty orders clean by
     disabling the textarea until the shopper opts in). Writes the
     text to the CART note (order.note at checkout) via AJAX on
     add-to-cart, rather than as a line-item property — a line-item
     property lands on whichever line the /cart/add request happens
     to touch, which read as "buried in the items" in the admin.
     Overwrites any existing cart note (single order-level message,
     last one typed wins); leaving the box unchecked/empty on a
     later add-to-cart never touches an existing note.
     --------------------------------------------------------- */
  function cartSetNote(note) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note })
    }).catch(function () { /* best-effort */ });
  }

  function bindGiftMsg() {
    document.querySelectorAll('[data-ah-giftmsg]').forEach(function (wrap) {
      if (wrap.dataset.ahBound) return;
      wrap.dataset.ahBound = '1';
      var cb = wrap.querySelector('[data-ah-giftmsg-toggle]');
      var field = wrap.querySelector('.ah-giftmsg__field');
      var ta = wrap.querySelector('[data-ah-giftmsg-input]');
      if (!cb || !field || !ta) return;
      cb.addEventListener('change', function () {
        field.hidden = !cb.checked;
        ta.disabled = !cb.checked;
        if (cb.checked) ta.focus();
      });

      var form = wrap.closest('form');
      if (form) {
        form.addEventListener('submit', function () {
          var note = ta.value.trim();
          if (cb.checked && note) cartSetNote(note);
        });
      }
    });
  }

  /* ---------------------------------------------------------
     PHASE 5b — Sticky Add-to-Cart bar: visible only once the real
     ATC button scrolls out of view; proxies the click to it.
     --------------------------------------------------------- */
  function bindStickyAtc() {
    var bar = document.querySelector('[data-ah-stickyatc]');
    if (!bar || bar.dataset.ahBound) return;
    var target = document.getElementById(bar.getAttribute('data-ah-target'));
    if (!target) return;
    bar.dataset.ahBound = '1';

    var addBtn = bar.querySelector('[data-ah-stickyatc-add]');
    if (addBtn) addBtn.addEventListener('click', function () { target.click(); });

    // Keep the sticky bar price in sync with the main PDP price, which Dawn
    // re-renders into #price-<sectionId> on every variant change. The sticky
    // bar sits outside that element, so mirror the .ah-price node across.
    var sectionId = (bar.getAttribute('data-ah-target') || '').replace('ProductSubmitButton-', '');
    var mainPrice = document.getElementById('price-' + sectionId);
    var stickyPrice = bar.querySelector('.ah-stickyatc__price');
    if (mainPrice && stickyPrice && 'MutationObserver' in window) {
      var syncStickyPrice = function () {
        var src = mainPrice.querySelector('.ah-price');
        if (!src) return;
        var clone = src.cloneNode(true);
        clone.className = 'ah-price ah-price--compact';
        stickyPrice.replaceChildren(clone);
      };
      syncStickyPrice();
      new MutationObserver(syncStickyPrice).observe(mainPrice, { childList: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.hidden = e.isIntersecting; });
      }, { threshold: 0 });
      io.observe(target);
    } else {
      bar.hidden = false;
    }
  }

  /* ---------------------------------------------------------
     PHASE 6 — Bonsai Shears add-on: checkbox adds/removes the
     shears variant in the cart via AJAX.
     --------------------------------------------------------- */
  function cartAdd(id) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.ok; })
      .then(function (ok) { return Promise.all([refreshCartCount(), updateCartUI()]).then(function () { return ok; }); })
      .catch(function () { return false; });
  }

  function cartRemove(id) {
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: 0 })
    })
      .then(function (r) { return r.ok; })
      .then(function (ok) { return Promise.all([refreshCartCount(), updateCartUI()]).then(function () { return ok; }); })
      .catch(function () { return false; });
  }

  function bindAddon() {
    document.querySelectorAll('[data-ah-addon]').forEach(function (wrap) {
      if (wrap.dataset.ahBound) return;
      wrap.dataset.ahBound = '1';
      var cb = wrap.querySelector('[data-ah-addon-check]');
      var status = wrap.querySelector('[data-ah-addon-status]');
      if (!cb) return;
      var vid = cb.getAttribute('data-variant-id');

      // Reflect cart state on load — OPT-IN only, never auto-add (the
      // cart-drawer upsell nudges shoppers who haven't added the shears).
      fetch(root() + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var inCart = cart.items.some(function (i) { return String(i.variant_id) === String(vid); });
          cb.checked = inCart;
          if (status) status.hidden = !inCart;
        })
        .catch(function () { /* skip silently */ });

      cb.addEventListener('change', function () {
        cb.disabled = true;
        (cb.checked ? cartAdd(vid) : cartRemove(vid)).then(function (ok) {
          cb.disabled = false;
          if (!ok) { cb.checked = !cb.checked; return; }
          if (status) status.hidden = !cb.checked;
        });
      });
    });
  }

  /* ---------------------------------------------------------
     ABANA — Cart drawer upsell "Add" button (e.g. bonsai shears).
     Adds the variant via AJAX, then the drawer re-renders (which
     removes the upsell card since the item is now in the cart).
     --------------------------------------------------------- */
  function bindCartAdd(scope) {
    (scope || document).querySelectorAll('[data-ah-cart-add]').forEach(function (btn) {
      if (btn.dataset.ahBound) return;
      btn.dataset.ahBound = '1';
      btn.addEventListener('click', function () {
        var vid = btn.getAttribute('data-ah-cart-add');
        if (!vid || btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        cartAdd(vid).then(function (ok) {
          if (!ok) { btn.disabled = false; btn.classList.remove('is-loading'); }
          // on success the drawer re-renders and this button is gone
        });
      });
    });
  }

  /* ---------------------------------------------------------
     ABANA — Editable promo / discount code field (cart drawer).
     Apply / remove via the Cart AJAX API ({ discount: 'A,B' }).
     Automatic discounts (JUN10 / BUY2GET20) are untouched.
     --------------------------------------------------------- */
  // Request the drawer sections back IN THE SAME mutation so the rendered HTML
  // (and its totals) is guaranteed consistent with the applied discount — no
  // separate read-after-write fetch that could render a pre-discount total.
  function cartSetDiscounts(codes) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        discount: codes,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: '/cart'
      })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  // Promo controls use DOCUMENT-LEVEL EVENT DELEGATION, bound exactly once.
  // Rationale: the cart drawer's inner HTML (incl. the whole .ah-promo block)
  // is destroyed + recreated on every re-render — Dawn's own renderContents on
  // add-to-cart (the drawer auto-opens with fresh HTML) AND our updateCartUI().
  // Per-element listeners bound at render time are lost on the very next
  // re-render, and re-binding after each render is racy (the "have another
  // code?" / Apply buttons silently went dead specifically on the PDP
  // add-to-cart path). Delegation on a stable root can't be defeated by any
  // re-render, so no ahBound bookkeeping or re-bind calls are needed.
  function bindPromo() {
    if (document.documentElement.dataset.ahPromoDelegated) return;
    document.documentElement.dataset.ahPromoDelegated = '1';

    function existingCodes(wrap) {
      var raw = wrap.getAttribute('data-ah-promo-codes') || '';
      return raw ? raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
    }
    function errEl(wrap) { return wrap.querySelector('[data-ah-promo-error]'); }
    function showError(wrap, msg) { var e = errEl(wrap); if (e) { e.textContent = msg; e.hidden = false; } }
    function clearError(wrap) { var e = errEl(wrap); if (e) { e.hidden = true; e.textContent = ''; } }

    function apply(wrap) {
      var input = wrap.querySelector('[data-ah-promo-input]');
      var applyBtn = wrap.querySelector('[data-ah-promo-apply]');
      if (!input) return;
      var code = (input.value || '').trim();
      if (!code) { showError(wrap, 'Please enter a promo code.'); return; }
      clearError(wrap);
      if (applyBtn) { applyBtn.disabled = true; applyBtn.classList.add('is-loading'); }
      var all = existingCodes(wrap).concat([code]);
      cartSetDiscounts(all.join(',')).then(function (cart) {
        if (applyBtn) { applyBtn.disabled = false; applyBtn.classList.remove('is-loading'); }
        if (!cart) {
          // network/API failure — say so, don't fall through to "invalid code"
          showError(wrap, 'Could not apply the code — please check your connection and try again.');
          return;
        }
        var ok = (cart.discount_codes || []).some(function (d) {
          return d.code.toLowerCase() === code.toLowerCase() && d.applicable;
        });
        if (ok) {
          input.value = '';
          // Render from the mutation's own sections payload (atomic, reflects
          // the new total); fall back to a fresh fetch if it wasn't returned.
          if (cart.sections) swapDrawerSections(cart.sections);
          else updateCartUI();
        } else {
          // roll back to the codes that were valid before, keep field open
          cartSetDiscounts(existingCodes(wrap).join(','));
          showError(wrap, '"' + code + '" isn\'t a valid promo code.');
        }
      });
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      // "have another code?" reveals the inline input (coupon/auto already applied).
      var changeBtn = t.closest('[data-ah-promo-change]');
      if (changeBtn) {
        var wrap = changeBtn.closest('[data-ah-promo]');
        if (!wrap) return;
        var applied = wrap.querySelector('[data-ah-promo-applied]');
        var edit = wrap.querySelector('[data-ah-promo-edit]');
        if (applied) applied.hidden = true;
        if (edit) {
          edit.hidden = false;
          var inp = edit.querySelector('[data-ah-promo-input]');
          if (inp) inp.focus();
        }
        return;
      }
      // "remove" clears the applied manual code(s). Automatic discounts are
      // NOT controlled by the cart discount field, so they simply re-evaluate
      // on the next render (e.g. the Buy-2-Bonsai auto discount reappears when
      // the cart still qualifies) — this only removes a stuck coupon code.
      var removeBtn = t.closest('[data-ah-promo-remove]');
      if (removeBtn) {
        var wrapRm = removeBtn.closest('[data-ah-promo]');
        if (!wrapRm) return;
        removeBtn.disabled = true;
        removeBtn.classList.add('is-loading');
        cartSetDiscounts('').then(function (cart) {
          if (cart && cart.sections) swapDrawerSections(cart.sections);
          else updateCartUI();
        });
        return;
      }
      var applyBtn = t.closest('[data-ah-promo-apply]');
      if (applyBtn) {
        var w = applyBtn.closest('[data-ah-promo]');
        if (w) apply(w);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (!t || !t.closest) return;
      var input = t.closest('[data-ah-promo-input]');
      if (!input) return;
      e.preventDefault();
      var w = input.closest('[data-ah-promo]');
      if (w) apply(w);
    });

    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var input = t.closest('[data-ah-promo-input]');
      if (!input) return;
      var w = input.closest('[data-ah-promo]');
      if (w) clearError(w);
    });
  }

  // "Notify Me" (back-in-stock capture) — same document-level delegation as
  // bindPromo, for the same reason: the buy-buttons block is re-rendered on
  // variant change, so per-element listeners would go dead.
  function bindNotify() {
    if (document.documentElement.dataset.ahNotifyDelegated) return;
    document.documentElement.dataset.ahNotifyDelegated = '1';

    var NOTIFY_ENDPOINT = 'https://cx.abanahomes.com/api/notify_signup.php';
    var STORAGE_PREFIX = 'ah_notify_variant_';

    function msgEl(wrap) { return wrap.querySelector('[data-ah-notify-msg]'); }
    function showMsg(wrap, text, isError) {
      var m = msgEl(wrap);
      if (!m) return;
      m.textContent = text;
      m.hidden = false;
      if (isError) m.setAttribute('data-ah-notify-error', '1');
      else m.removeAttribute('data-ah-notify-error');
    }

    function alreadyRequested(variantId) {
      try { return window.localStorage.getItem(STORAGE_PREFIX + variantId) === '1'; }
      catch (e) { return false; }
    }
    function rememberRequested(variantId) {
      try { window.localStorage.setItem(STORAGE_PREFIX + variantId, '1'); } catch (e) {}
    }

    function paintDone(wrap, text) {
      wrap.setAttribute('data-ah-notify-done', '1');
      showMsg(wrap, text, false);
    }

    function submit(wrap) {
      var variantId = wrap.getAttribute('data-ah-variant-id');
      var productId = wrap.getAttribute('data-ah-product-id');
      if (!variantId || !productId) return;

      if (alreadyRequested(variantId)) {
        paintDone(wrap, "You're already on the list for this item — we'll WhatsApp you when it's back.");
        return;
      }

      var phoneInput = wrap.querySelector('[data-ah-notify-phone]');
      var btn = wrap.querySelector('[data-ah-notify-submit]');
      var phone = (phoneInput && phoneInput.value || '').trim();

      if (!/^[6-9]\d{9}$/.test(phone.replace(/\D/g, '').replace(/^91/, '').slice(-10)) || phone.replace(/\D/g, '').length < 10) {
        showMsg(wrap, 'Please enter a valid 10-digit phone number.', true);
        return;
      }

      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }

      fetch(NOTIFY_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          phone: phone,
          product_id: productId,
          variant_id: variantId,
          product_title: wrap.getAttribute('data-ah-product-title') || '',
          variant_title: wrap.getAttribute('data-ah-variant-title') || '',
          page_url: window.location.href
        })
      })
        .then(function (res) { return res.json().catch(function () { return {}; }).then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (result) {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          if (!result.ok) {
            showMsg(wrap, (result.data && result.data.error) || 'Something went wrong — please try again.', true);
            return;
          }
          rememberRequested(variantId);
          paintDone(wrap, "You're on the list — we'll WhatsApp you as soon as it's back in stock.");
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
          showMsg(wrap, 'Could not reach the server — please check your connection and try again.', true);
        });
    }

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var submitBtn = t.closest('[data-ah-notify-submit]');
      if (!submitBtn) return;
      var wrap = submitBtn.closest('[data-ah-notify]');
      if (wrap) submit(wrap);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var t = e.target;
      if (!t || !t.closest) return;
      var field = t.closest('[data-ah-notify-phone]');
      if (!field) return;
      e.preventDefault();
      var wrap = field.closest('[data-ah-notify]');
      if (wrap) submit(wrap);
    });
  }

  // Paint the "already requested" state for a given notify block as soon as
  // it's in the DOM (e.g. after a variant swap re-renders buy-buttons).
  function paintNotifyState() {
    document.querySelectorAll('[data-ah-notify]').forEach(function (wrap) {
      var variantId = wrap.getAttribute('data-ah-variant-id');
      if (!variantId) return;
      try {
        if (window.localStorage.getItem('ah_notify_variant_' + variantId) === '1') {
          wrap.setAttribute('data-ah-notify-done', '1');
          var m = wrap.querySelector('[data-ah-notify-msg]');
          if (m) { m.hidden = false; m.textContent = "You're already on the list for this item — we'll WhatsApp you when it's back."; }
        }
      } catch (e) {}
    });
  }

  /* --- init --- */
  function init() {
    bindHover();
    bindCartSync();
    bindGiftMsg();
    bindStickyAtc();
    bindAddon();
    bindCartAdd();
    bindPromo();
    bindNotify();
    paintNotifyState();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Re-bind when sections are re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function () {
    bindHover();
    bindGiftMsg();
    bindStickyAtc();
    bindAddon();
    paintNotifyState();
  });

  // Dawn's <product-info> dispatches this after an AJAX variant re-render
  // (new buy-buttons markup, no section:load) — repaint "already
  // requested" state for the just-rendered notify block.
  document.addEventListener('product-info:loaded', paintNotifyState);
})();
